import { NCIBigFooter } from './nci-big-footer.component';
NCIBigFooter.autoInit();
